var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ol",
    { staticClass: "breadcrumb" },
    _vm._l(_vm.list, function(item, index) {
      return _c(
        "li",
        { staticClass: "breadcrumb-item" },
        [
          _vm.isLast(index)
            ? _c("span", { staticClass: "active" }, [
                _vm._v(_vm._s(_vm.$t(_vm.showName(item))))
              ])
            : _c("router-link", { attrs: { to: item } }, [
                _vm._v(_vm._s(_vm.$t(_vm.showName(item))))
              ])
        ],
        1
      )
    })
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f46de9a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f46de9a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumb.vue
// module id = 938
// module chunks = 2